"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getGrid2UtilityClass = getGrid2UtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("@mui/utils/generateUtilityClasses"));
var _generateUtilityClass = _interopRequireDefault(require("@mui/utils/generateUtilityClass"));
function getGrid2UtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiGrid2', slot);
}
const SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const grid2Classes = (0, _generateUtilityClasses.default)('MuiGrid2', [
    'root',
    'container',
    // spacings
    ...SPACINGS.map((spacing)=>"spacing-xs-".concat(spacing)),
    // direction values
    ...DIRECTIONS.map((direction)=>"direction-xs-".concat(direction)),
    // wrap values
    ...WRAPS.map((wrap)=>"wrap-xs-".concat(wrap)),
    // grid sizes for all breakpoints
    ...GRID_SIZES.map((size)=>"grid-xs-".concat(size)),
    ...GRID_SIZES.map((size)=>"grid-sm-".concat(size)),
    ...GRID_SIZES.map((size)=>"grid-md-".concat(size)),
    ...GRID_SIZES.map((size)=>"grid-lg-".concat(size)),
    ...GRID_SIZES.map((size)=>"grid-xl-".concat(size))
]);
var _default = exports.default = grid2Classes;
